var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-sm":""}},[_c('ProjectResponseHeader'),_c('br'),_c('ProjectResponseMenuTab',{attrs:{"active":2}}),_c('br'),_c('v-layout',[_c('v-flex',{attrs:{"sm12":""}},[_c('ProjectPreviewContent')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }